import React from 'react';

import Alert from 'ui/Alert';
import Link from 'ui/Link';

import { websiteLinkTo } from '../../utils/routes';
import { useCurrentUser } from '../../utils/user';

// TODO: Rename component to ...Alert
const CustomerExceededSankeysLimitBanner: React.FC = () => {
  const { user } = useCurrentUser();

  if (
    user &&
    user.has_active_subscription &&
    user.remaining_nr_of_sankeys < 0
  ) {
    return (
      <Alert
        status="error"
        title={`You've crossed your allowed limit of ${user.allowed_nr_of_sankeys} diagrams`}
      >
        Your diagrams won't be saved until you{' '}
        <Link
          href={websiteLinkTo('/subscriptions/')}
          variant="subtle"
          isExternal
        >
          upgrade your plan
        </Link>{' '}
        or{' '}
        <Link href={websiteLinkTo('/sankeys/')} variant="subtle" isExternal>
          delete some diagrams
        </Link>
        .
      </Alert>
    );
  }

  return null;
};

export default CustomerExceededSankeysLimitBanner;
